import React, { useEffect, useRef } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../app/store";
import pinCharIcon from "../assets/pin_chat_icon.png";
import renameCharIcon from "../assets/rename_chat_icon.png";
// import shareChatIcon from "../assets/share_char_small_icon.png";
import { pinChat, pinFolder } from "../features/folderSlice";
import { openModal } from "../features/modalSlice";
import { togglePin } from "../features/pinSlice";
import { toggleMinimize } from "../features/themeSlice";
import { OptionsMenuProps } from "../types";

const OptionsMenu: React.FC<OptionsMenuProps> = ({ position, toggleOptions, pin, type, name,IsMessageLength }) => {
  const dispatch = useDispatch<AppDispatch>();
  const chatId12 = useSelector((state: RootState) => state.chat.activeChatId);
  const chatId1 = typeof chatId12 === "string" ? parseInt(chatId12, 10) : chatId12;
  // const navigate = useNavigate();
  const handlePin = async () => {
    try {
      let message;
      if (type === "chat") {
        console.log("chat");
        message = await dispatch(pinChat(chatId1)).unwrap();
        dispatch(togglePin(chatId1));
      }
      if (type === "folder") {
        console.log("folder");
        message = await dispatch(pinFolder(chatId1)).unwrap();
        dispatch(togglePin(chatId1));
      }
      if (type === "chat") {
        toast.success(message ? "Successfully pinned Chat" : "Chat unpinned successfully", {
          className:
            "md:!bg-[#00B21B]/20 !bg-[#00B21B]/100 dark:!text-white dark:text-[#191919] !shadow-none",
          duration: 2000,
        });
      }
      if (type === "folder") {
        toast.success(message ? "Successfully pinned Folder" : "Folder unpinned successfully", {
          className:
            "md:!bg-[#00B21B]/20 !bg-[#00B21B]/100 dark:!text-white dark:text-[#191919] !shadow-none",
          duration: 2000,
        });
      }
    } catch (error) {
      toast.error("error", {
        className:
          "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
        duration: 2000,
      });
    }
  };
  const deleteChat = async (id: number, type: string, name: string | undefined) => {
    if(IsMessageLength){
      toast.error("To delete this folder, you must first delete the chats.", {
        className:
          "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
        duration: 2000,
      });
    }else{
      dispatch(
        openModal({
          name: "ModalDeleteChat",
          props: { id: id, type: type, name: name }, // Pass required props here
        })
      );
      toggleOptions(false);
    }
    // navigate("/chat"); // Navigate first
  };
  const menuRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        toggleOptions(false); // Close the menu
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [toggleOptions]);

  return (
    <div
      className="absolute left-1/2 transform -translate-x-1/2  z-50 ml-2 mt-5 options-menu  bg-transparen dark:bg-transparent dark:bg-opacity-80 dark:backdrop-blur-[42px] bg-opacity-80 backdrop-blur-[42px] rounded-lg max-w-[158px] w-full p-2 border-[1px] border-[#D1D1D1] dark:border-none"
      style={{
        left: position.left,
        top: position.top,
      }}
      ref={menuRef}
    >
      <ul className="space-y-2 text-sm dark:text-[#D1D1D1] bg-transparent dark:bg-opacity-80  dark:backdrop-blur-[42px]">
        <li className="hover:bg-[#ffffffd1] rounded-sm dark:hover:bg-[#192c3a] px-3 py-2 cursor-pointer items-center flex">
          <button
            className="flex items-center w-full gap-3"
            onClick={(e) => {
              e.stopPropagation(); // Prevent the click event from propagating to the parent button
              if (window.innerWidth < 768) {
                dispatch(toggleMinimize());
              }

              dispatch(
                openModal({
                  name: "ModalRenameChat",
                  props: { id: chatId1, type: type, name: name }, // Pass required props here
                })
              );
              toggleOptions(false);
            }}
            onKeyDown={(e) => {
              // Trigger the click event on Enter or Space key press
              if (e.key === "Enter" || e.key === " ") {
                e.stopPropagation(); // Prevent the click event from propagating
                dispatch(
                  openModal({
                    name: "ModalRenameChat",
                    props: { id: chatId1, type: type, name: name }, // Pass required props here
                  })
                );
                toggleOptions(false);
              }
            }}
          >
            <img
              src={renameCharIcon}
              alt="rename"
              className="text-xs w-[11px] object-cover invert dark:invert-0"
            />{" "}
            Rename
          </button>
        </li>
        {/* {type === "chat" && (
          <li className="hover:bg-[#ffffffd1] rounded-sm dark:hover:bg-[#192c3a] px-3 py-2 cursor-pointer items-center flex">
            <button
              className="flex items-center w-full gap-3"
              onClick={() => {
                toggleOptions(false);
              }}
            >
              <img
                src={shareChatIcon}
                alt="share_chat"
                className="text-xs w-[13.44px] object-cover invert dark:invert-0"
              />{" "}
              Share
            </button>
          </li>
        )} */}
        <li className="hover:bg-[#ffffffd1] rounded-sm dark:hover:bg-[#192c3a] px-3 py-2 cursor-pointer items-center flex">
          <button
            className="flex items-center w-full gap-3"
            onClick={() => {
              handlePin();
              toggleOptions(false);
            }}
          >
            <img
              src={pinCharIcon}
              alt="pin chat"
              className="text-xs w-[12.21px] object-cover invert dark:invert-0"
            />
            {pin ? `Unpin ${type}` : `Pin ${type}`}
          </button>
        </li>
        <li className="hover:bg-[#ffffffd1] rounded-sm dark:hover:bg-[#192c3a] px-3 py-2 cursor-pointer items-center text-[#ff0000d9] dark:text-[#FFA8A8] flex">
          <button
            className="flex items-center w-full gap-3"
            onClick={(e) => {
              e.stopPropagation();
              deleteChat(chatId1, type, name);
            }}
          >
            <svg
              id="Group_17438"
              data-name="Group 17438"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="11.428"
              height="13.095"
              viewBox="0 0 11.428 13.095"
            >
              <defs>
                <clipPath id="clip-path">
                  <rect
                    id="Rectangle_16756"
                    data-name="Rectangle 16756"
                    width="11.428"
                    height="13.095"
                    fill="currentColor"
                  />
                </clipPath>
              </defs>
              <g id="Group_17437" data-name="Group 17437" clipPath="url(#clip-path)">
                <path
                  id="Path_41602"
                  data-name="Path 41602"
                  d="M.951,24.952c-.172,0-.321,0-.469,0A.476.476,0,1,1,.476,24H.565q5.148,0,10.3,0a.787.787,0,0,1,.3.054.463.463,0,0,1,.258.505.479.479,0,0,1-.447.39c-.158.007-.317,0-.5,0v.192q0,4.27,0,8.54a1.943,1.943,0,0,1-1.537,1.934,2.041,2.041,0,0,1-.442.046q-2.782,0-5.564,0A1.949,1.949,0,0,1,.952,33.683q0-4.27,0-8.54Zm8.57.011H1.9v.173q0,4.239,0,8.478a1.008,1.008,0,0,0,1.1,1.1h5.4A1.011,1.011,0,0,0,9.521,33.6q0-4.224,0-8.448Z"
                  transform="translate(0 -22.571)"
                  fill="currentColor"
                />
                <path
                  id="Path_41603"
                  data-name="Path 41603"
                  d="M58.366.954c-.634,0-1.268,0-1.9,0a.475.475,0,0,1-.121-.936A.469.469,0,0,1,56.46,0q1.9,0,3.8,0a.475.475,0,0,1,.107.94.828.828,0,0,1-.177.012H58.366"
                  transform="translate(-52.651 -0.001)"
                  fill="currentColor"
                />
                <path
                  id="Path_41604"
                  data-name="Path 41604"
                  d="M60.944,78.87c0,.783,0,1.565,0,2.348a.475.475,0,0,1-.937.131.607.607,0,0,1-.015-.147q0-2.348,0-4.7a.476.476,0,0,1,.936-.146.8.8,0,0,1,.016.191q0,1.159,0,2.319"
                  transform="translate(-56.42 -71.474)"
                  fill="currentColor"
                />
                <path
                  id="Path_41605"
                  data-name="Path 41605"
                  d="M116.928,78.883q0,1.174,0,2.348a.462.462,0,0,1-.3.455.448.448,0,0,1-.508-.1.5.5,0,0,1-.148-.39q0-1.627,0-3.255c0-.471,0-.941,0-1.412a.478.478,0,1,1,.952,0q0,1.174,0,2.348"
                  transform="translate(-109.072 -71.486)"
                  fill="currentColor"
                />
              </g>
            </svg>
            Delete
          </button>
        </li>
      </ul>
    </div>
  );
};

export default OptionsMenu;
